/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type { AssetModelResponse, GetAssetModelsParams } from '../models';

export type getAssetModelsResponse200 = {
    data: AssetModelResponse[];
    status: 200;
};

export type getAssetModelsResponse400 = {
    data: void;
    status: 400;
};

export type getAssetModelsResponse500 = {
    data: void;
    status: 500;
};

export type getAssetModelsResponseSuccess = getAssetModelsResponse200 & {
    headers: Headers;
};

export type getAssetModelsResponseError = (
    | getAssetModelsResponse400
    | getAssetModelsResponse500
) & {
    headers: Headers;
};

export type getAssetModelsResponse = getAssetModelsResponseSuccess | getAssetModelsResponseError;

export const getGetAssetModelsUrl = (params?: GetAssetModelsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/asset-models?${stringifiedParams}`
        : `/api/v1/asset-models`;
};

export const getAssetModels = async (
    params?: GetAssetModelsParams,
    options?: RequestInit
): Promise<getAssetModelsResponse> => {
    const res = await fetch(getGetAssetModelsUrl(params), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getAssetModelsResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getAssetModelsResponse;
};
